<template>
  <s-topbar :color="color" >
    <template #left @click="goToHome">
      <img 
        src="@/public/logo/icon_large.png"
        alt="Logo"
        height="32px"
      />
      <h3 class="topbar-title">Portal Quinyx</h3>
    </template>

    <template #right>
      <topbar-escola-popover v-model:color="color" v-if="showEscolaPopover" />
      <s-divider orientation="vertical" length="80%" v-if="showEscolaPopover" />
      <topbar-usuario-popover />
    </template>
  </s-topbar>
</template>

<script lang="ts" setup>
import { SDivider, STopbar, type Color } from '@sieg-ad/componentes-vue';
import { useAuthStore } from '~/stores/auth';

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);

const color = ref<Color>('secondary');

const showEscolaPopover = computed(() => user.value?.tipo_id === 3);

</script>

<style>
.topbar-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-left: 8px;
  color: var(--primary);
}
</style>